// src/Admin/BuscadorDocumentos.js
// Mejoras:
//   - Búsqueda por Num_Identificacion (DNI/NIE/CIF)
//   - Columna CVE en resultados (si el documento está asociado a un expediente)

import React, { useEffect, useState } from "react";
import { Form, Button, Table, Modal, Badge, InputGroup } from "react-bootstrap";

const BuscadorDocumentos = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [resultados, setResultados] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [expedientes, setExpedientes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [documentoAEliminar, setDocumentoAEliminar] = useState(null);

  useEffect(() => {
    getUsuarios();
    getDocumentos();
    getExpedientes();
  }, []);

  const getUsuarios = async () => {
    try {
      const res = await fetch("https://sectorb12.info/api/usuarios");
      if (res.ok) setUsuarios(await res.json());
    } catch (e) { console.error(e); }
  };

  const getDocumentos = async () => {
    try {
      const res = await fetch("https://sectorb12.info/api/documentos");
      if (res.ok) setDocumentos(await res.json());
    } catch (e) { console.error(e); }
  };

  const getExpedientes = async () => {
  try {
    const res = await fetch("https://sectorb12.info/api/expedientes", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (res.ok) setExpedientes(await res.json());
  } catch (e) { console.error(e); }
};

  const handleBuscar = (e) => {
    e.preventDefault();
    const term = textoBusqueda.trim().toUpperCase();
    if (!term) return;

    // Buscar por Num_Identificacion (DNI/NIE/CIF)
    const usuariosFiltrados = usuarios.filter((u) =>
      u.Num_Identificacion?.toUpperCase().includes(term)
    );

    const documentosFiltrados = documentos.filter((doc) =>
      usuariosFiltrados.some((u) => u.UsuarioID === doc.usuario_id)
    );

    const resultadosConDatos = documentosFiltrados.map((doc) => {
      const usuario = usuarios.find((u) => u.UsuarioID === doc.usuario_id);
      // Buscar CVE: expedientes cuya solicitud esté asociada al usuario
      const expediente = expedientes.find((exp) => exp.UsuarioID === doc.usuario_id);
      return { ...doc, usuario, cve: expediente?.CodigoCVE || null };
    });

    setResultados(resultadosConDatos);
  };

  const handleDownload = (doc) => {
    const binaryData = atob(doc.Documento);
    const blob = new Blob([
      new Uint8Array(binaryData.split("").map((c) => c.charCodeAt(0))),
    ]);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = doc.NombreDocumento || "documento.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleEliminar = async (id) => {
    try {
      const res = await fetch(`https://sectorb12.info/api/documentos/${id}`, {
        method: "DELETE",
      });
      if (res.ok) {
        setDocumentos((prev) => prev.filter((d) => d.DocumentoID !== id));
        setResultados((prev) => prev.filter((d) => d.DocumentoID !== id));
        setShowModal(false);
      }
    } catch (e) { console.error(e); }
  };

  return (
    <div>
      <Form onSubmit={handleBuscar}>
        <Form.Group controlId="textoBusqueda">
          <Form.Label>Buscar por DNI / NIE / CIF</Form.Label>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Ej: 12345678A"
              value={textoBusqueda}
              onChange={(e) => setTextoBusqueda(e.target.value)}
            />
            <Button variant="success" type="submit">
              <i className="bi bi-search me-1"></i> 
            </Button>
          </InputGroup>
          <Form.Text className="text-muted">
            Introduzca el número de identificación completo o parcial.
          </Form.Text>
        </Form.Group>
      </Form>

      {resultados.length > 0 && (
        <div className="mt-4">
          <h6 className="mb-2 text-muted">
            {resultados.length} documento{resultados.length !== 1 ? "s" : ""} encontrado
            {resultados.length !== 1 ? "s" : ""}
          </h6>
          <div className="table-responsive">
            <Table hover className="mt-2 align-middle">
              <thead className="table-light">
                <tr>
                  <th>Nombre del documento</th>
                  <th>Usuario</th>
                  <th>Identificación</th>
                  <th>Fecha de subida</th>
                  <th>CVE</th>
                  <th>Firmado admin</th>
                  <th>Descargar</th>
                  <th>Eliminar</th>
                </tr>
              </thead>
              <tbody>
                {resultados.map((doc) => (
                  <tr key={doc.DocumentoID}>
                    <td>{doc.NombreDocumento}</td>
                    <td>
                      {doc.usuario?.Nombre} {doc.usuario?.Apellidos}
                    </td>
                    <td>{doc.usuario?.Num_Identificacion}</td>
                    <td>{doc.FechaSubida?.split(" ")[0]}</td>
                    <td>
                      {doc.cve ? (
                        <code className="text-primary">{doc.cve}</code>
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>
                      <Badge bg={doc.FirmadoAdmin ? "success" : "secondary"}>
                        {doc.FirmadoAdmin ? "Sí" : "No"}
                      </Badge>
                    </td>
                    <td>
                      <Button
                        variant="outline-dark"
                        size="sm"
                        onClick={() => handleDownload(doc)}
                      >
                         Descargar
                      </Button>
                    </td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => {
                          setDocumentoAEliminar(doc.DocumentoID);
                          setShowModal(true);
                        }}
                      >
                        Eliminar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}

      {resultados.length === 0 && textoBusqueda && (
        <p className="text-muted mt-3">No se encontraron documentos para esa identificación.</p>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Está seguro de que desea eliminar este documento?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="danger" onClick={() => handleEliminar(documentoAEliminar)}>Eliminar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BuscadorDocumentos;